import { render } from "./DuplicatedPatientDialog.vue?vue&type=template&id=2283845c&scoped=true"
import script from "./DuplicatedPatientDialog.vue?vue&type=script&lang=js"
export * from "./DuplicatedPatientDialog.vue?vue&type=script&lang=js"

import "./DuplicatedPatientDialog.vue?vue&type=style&index=0&id=2283845c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2283845c"]])

export default __exports__